import { PickerAbstract } from "./PickerAbstract";
import { easepick, LockPlugin } from "@easepick/bundle";
import { Core } from "@easepick/core";
import { MonthPickerPlugin } from "../../EasePick/month-picker-plugin/MonthPickerPlugin";

export class PickerMonth extends PickerAbstract {
    declare easepick: Core;
    declare trigger: HTMLElement;

    initElements() {
        this.presentationFormat = "MM.YYYY";
        return super.initElements();
    }

    createCalendar(id: string) {
        this.createTrigger();
        // @ts-ignore
        this.easepick = new easepick.create({
            element: this.trigger,
            css: [this.cssPath],
            format: this.dateFormat,
            zIndex: 0,
            grid: 1,
            calendars: 1,
            inline: false,
            readonly: false,
            autoApply: false,
            scrollToDate: true,
            lang: this.lang,
            locale: {
                cancel: this.cancel,
                apply: this.apply
            },
            LockPlugin: {
                maxDate: this.max,
                minDate: this.min
            },
            MonthPickerPlugin: {
                minYear: this.minYear,
                maxYear: this.maxYear,
                resetButton: true
            },
            plugins: [LockPlugin, MonthPickerPlugin],
            setup: (picker: Core) => {
                picker.ui.wrapper.id = id;
            }
        });

        return this;
    }
}

customElements.define("x-month-picker", PickerMonth);
